export const FORM_FIELD_ERROR_TYPES = {
  NO_FIELD_NAME: 'NO_FIELD_NAME',
  INVALID_FORM_FIELD: 'INVALID_FORM_FIELD',
  UPDATE_ERROR: 'UPDATE_ERROR'
};